export default __webpack_public_path__ + "static/media/tab-staff-4-strings.1fa6103d.png";